/**
 * Dummy shopify.js
 * Created to stop 404 console error from missing script reference.
 * This file is intentionally left empty to prevent loading errors.
 */
console.log("shopify.js loaded (dummy file)");
